import {
    Flex,
    Input,
    InputGroup,
    InputLeftElement,
    Button,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

const EightByEightLicenceTreeToolbar = ({
    onAllDisabled,
    onAllEnabled,
    allDisabled,
    search,
    onSearchChange,
    darkMode,
    borderColor,
}) => (
    <Flex justify="space-between" align="center" mb={2} gap={3} flexWrap="wrap">
        <Flex gap={2}>
            <Button
                size="sm"
                variant={allDisabled ? 'solid' : 'outline'}
                colorScheme="gray"
                bg={allDisabled ? 'gray.600' : undefined}
                color={allDisabled ? 'white' : undefined}
                _hover={{ bg: allDisabled ? 'gray.700' : undefined }}
                onClick={onAllDisabled}>
                All Disabled
            </Button>
            <Button
                size="sm"
                colorScheme="messenger"
                variant={allDisabled ? 'outline' : 'solid'}
                onClick={onAllEnabled}>
                All Enabled
            </Button>
        </Flex>
        <InputGroup maxW="240px" size="sm">
            <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" />
            </InputLeftElement>
            <Input
                placeholder="Search license..."
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') e.preventDefault();
                }}
                bg={darkMode ? 'dark.bgDark' : undefined}
                color={darkMode ? 'dark.textDark' : undefined}
                borderColor={darkMode ? borderColor : undefined}
            />
        </InputGroup>
    </Flex>
);

export default EightByEightLicenceTreeToolbar;
